import axios from 'axios'
import { useQueryClient } from 'react-query'
import { useRouter } from 'next/router'

import ProfileRevampPage from 'app/ProfileRevampPage'
import { getDeviceId } from 'utils/deviceId'
import ErrorBoundary from 'app/ProfileRevampPage/components/ErrorBoundary'
import { ERROR_STATE_TRACKER_ACTIVITY_TYPE } from 'app/SearchPage/constants'
import { useSETrackEventCertificates } from 'app/ProfileRevampPage/hooks/useSETrackEventCertificates'
import { getErrorType } from 'app/ProfileRevampPage/utils/error'
import { useProfileLayout } from 'stores/profile'

import type { TResponseSuccessGetProfileById } from 'types/profile'
import type { AxiosResponse } from 'axios'

export async function getServerSideProps(context) {
  const { id } = context.params
  const apiPath = `/guru/teachers/v1alpha2/internal/profiles/${id}`
  let metaTags = {}
  try {
    let response = (
      await axios.get<any, AxiosResponse<TResponseSuccessGetProfileById>>(
        `${process.env.NEXT_PUBLIC_INTERNAL_API_HOST}${apiPath}`,
        {
          timeout: 2000, // Set a timeout of 2 seconds
        }
      )
    ).data
    let data = JSON.parse(JSON.stringify(response.data))
    const name = data.name
    metaTags = {
      'og:title': `Profil Guru - ${name}`,
      'og:description': `Kunjungi profil milik rekan guru`,
      'og:url': `${process.env.NEXT_PUBLIC_BASE_URL}/profil/${id}`,
      'og:type': 'website',
    }
    return {
      props: {
        id,
        metaTags,
        appDeviceID: getDeviceId(context),
      },
    }
  } catch (e) {
    return {
      props: {
        id,
        metaTags,
        appDeviceID: getDeviceId(context),
      },
    }
  }
}

const ProfilPage = () => {
  const queryClient = useQueryClient()
  const router = useRouter()
  const profileId = router?.query?.id as string
  const profileLayoutStore = useProfileLayout()
  const { SETrackCertificateError } = useSETrackEventCertificates()

  const resetBoundaryHandler = (errorType) => {
    const queryKeys = {
      KARYA: `/guru/teachers/v1alpha2/users/profiles/${profileId}`,
      SERTIFIKAT: ['profile-certificates', profileId],
    }

    if (!ERROR_STATE_TRACKER_ACTIVITY_TYPE?.[errorType]) return

    SETrackCertificateError('CLICK_TRY_AGAIN', {
      event_trigger: ERROR_STATE_TRACKER_ACTIVITY_TYPE[errorType],
      source: 'PROFILE_PAGE',
      page_element: profileLayoutStore.pageElement,
    })
    queryClient.refetchQueries({
      queryKey: queryKeys[profileLayoutStore.pageElement],
    })
  }

  const errorBoundaryHandler = (error) => {
    const errorType = getErrorType(error)
    if (!ERROR_STATE_TRACKER_ACTIVITY_TYPE?.[errorType]) return

    SETrackCertificateError(ERROR_STATE_TRACKER_ACTIVITY_TYPE[errorType], {
      page_element: profileLayoutStore.pageElement,
    })
  }

  return (
    <ErrorBoundary
      resetKeys={[router.asPath]}
      onReset={resetBoundaryHandler}
      onError={errorBoundaryHandler}
    >
      <ProfileRevampPage />
    </ErrorBoundary>
  )
}

// eslint-disable-next-line react/display-name
ProfilPage.Layout = ({ children }) => children

export default ProfilPage
